import React from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import { translate } from '@portal/services/i18n';
import { useTheme } from '@material-ui/core';

const ErrorComponent = () => {
  const { palette } = useTheme();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CloseCircleFilled
        style={{
          fontSize: '10vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: palette.error.main ?? '#FF0000',
        }}
      />
      <p style={{ marginTop: 30 }}>
        {translate('APPLICATION.ERRORS.TRANSACTION_ERROR')}
      </p>
    </div>
  );
};

export default ErrorComponent;
